module.exports = __webpack_public_path__ + "img/Skillers_ikonok14-B9823D48-19B3-44B3-8B21-13109E77F9B7.60ffdcb4.png";